/* Cushion theme — product page */
(() => {
  const formatMoney = (cents) => {
    const format = window.moneyFormat || 'Rs.{{amount}}';
    const value = (cents / 100);
    const withCommas = (n, decimals) => n.toFixed(decimals).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    const strip = (s) => s.replace(/\.00$/, '').replace(/,00$/, '');
    return format.replace(/\{\{\s*(\w+)\s*\}\}/, (_, key) => {
      switch (key) {
        case 'amount_no_decimals': return withCommas(Math.round(value), 0);
        case 'amount_with_comma_separator': return strip(withCommas(value, 2).replace(/,/g, '#').replace('.', ',').replace(/#/g, '.'));
        case 'amount_no_decimals_with_comma_separator': return withCommas(Math.round(value), 0).replace(/,/g, '.');
        default: return strip(withCommas(value, 2));
      }
    });
  };

  document.querySelectorAll('[data-product]').forEach((root) => {
    const jsonEl = root.querySelector('[data-product-json]');
    if (!jsonEl) return;
    const product = JSON.parse(jsonEl.textContent);
    const idInput = root.querySelector('[data-variant-id]');
    const addButton = root.querySelector('[data-add-button]');
    const stickyBar = root.querySelector('[data-sticky-buy]');
    const stickyAdd = root.querySelector('[data-sticky-add]');

    /* ---------- Gallery ---------- */
    const track = root.querySelector('[data-gallery-track]');
    const slides = track ? [...track.children] : [];
    const thumbs = [...root.querySelectorAll('[data-gallery-thumb]')];
    const dots = [...root.querySelectorAll('[data-gallery-dot]')];
    const markActive = (i) => {
      thumbs.forEach((t, n) => t.setAttribute('aria-current', n === i ? 'true' : 'false'));
      dots.forEach((d, n) => d.setAttribute('aria-current', n === i ? 'true' : 'false'));
    };
    const showMedia = (mediaId, smooth = true) => {
      const i = slides.findIndex((s) => s.dataset.mediaId === String(mediaId));
      if (i < 0 || !track) return;
      track.scrollTo({ left: slides[i].offsetLeft, behavior: smooth ? 'smooth' : 'auto' });
      markActive(i);
    };
    thumbs.forEach((thumb) => thumb.addEventListener('click', () => showMedia(thumb.dataset.galleryThumb)));
    if (track) {
      let t;
      track.addEventListener('scroll', () => {
        clearTimeout(t);
        t = setTimeout(() => markActive(Math.round(track.scrollLeft / track.clientWidth)), 60);
      }, { passive: true });
      // Pause any playing video when swiping away
      track.addEventListener('scroll', () => track.querySelectorAll('video').forEach((v) => v.pause()), { passive: true });
    }

    /* ---------- Variants ---------- */
    const picker = root.querySelector('[data-variant-picker]');
    const selectedOptions = () => {
      if (!picker) return null;
      const values = [];
      picker.querySelectorAll('input[type="radio"]:checked').forEach((input) => {
        values[Number(input.dataset.optionIndex)] = input.value;
      });
      return values;
    };
    const findVariant = (values) => product.variants.find((v) => v.options.every((opt, i) => opt === values[i]));

    const setButtons = (variant) => {
      const available = variant && variant.available;
      const label = !variant ? 'Unavailable' : available ? 'Add to cart' : 'Sold out';
      [addButton, stickyAdd].forEach((btn) => {
        if (!btn) return;
        btn.disabled = !available;
        btn.textContent = label;
      });
    };

    const markUnavailable = (values) => {
      if (!picker) return;
      picker.querySelectorAll('input[type="radio"]').forEach((input) => {
        const idx = Number(input.dataset.optionIndex);
        const test = [...values];
        test[idx] = input.value;
        const match = findVariant(test);
        input.nextElementSibling?.classList.toggle('is-unavailable', !match || !match.available);
      });
    };

    const updateVariant = () => {
      const values = selectedOptions();
      if (!values) return;
      values.forEach((v, i) => {
        const label = root.querySelector(`[data-option-label="${i}"]`);
        if (label) label.textContent = v;
      });
      markUnavailable(values);
      const variant = findVariant(values);
      setButtons(variant);
      if (!variant) return;

      idInput.value = variant.id;
      const onSale = variant.compare_at_price && variant.compare_at_price > variant.price;
      const saveText = onSale ? `Save ${formatMoney(variant.compare_at_price - variant.price)}` : '';
      root.querySelectorAll('[data-price-current], [data-sticky-price]').forEach((el) => { el.textContent = formatMoney(variant.price); });
      root.querySelectorAll('[data-price-compare]').forEach((el) => { el.hidden = !onSale; if (onSale) el.textContent = formatMoney(variant.compare_at_price); });
      root.querySelectorAll('[data-price-save], [data-gallery-badge]').forEach((el) => { el.hidden = !onSale; el.textContent = saveText; });

      const stock = root.querySelector('[data-low-stock]');
      if (stock) {
        const threshold = Number(stock.dataset.threshold);
        const qty = variant.inventory_quantity;
        const tracked = variant.inventory_management === 'shopify';
        const show = tracked && qty > 0 && qty <= threshold;
        stock.hidden = !show;
        if (show) stock.querySelector('[data-low-stock-count]').textContent = qty;
      }

      if (variant.featured_media) showMedia(variant.featured_media.id);
      const url = new URL(window.location.href);
      url.searchParams.set('variant', variant.id);
      window.history.replaceState({}, '', url.toString());
    };
    picker?.addEventListener('change', updateVariant);
    if (picker) markUnavailable(selectedOptions());

    /* ---------- Quantity ---------- */
    root.querySelectorAll('[data-qty-step]').forEach((btn) => {
      btn.addEventListener('click', () => {
        const input = btn.parentElement.querySelector('input');
        const next = Math.max(1, (parseInt(input.value, 10) || 1) + Number(btn.dataset.qtyStep));
        input.value = next;
      });
    });

    /* ---------- Sticky bar ---------- */
    if (stickyBar && addButton && 'IntersectionObserver' in window) {
      const footer = document.querySelector('.site-footer');
      let buttonVisible = true;
      let footerVisible = false;
      const sync = () => {
        const show = !buttonVisible && !footerVisible && addButton.getBoundingClientRect().top < 0;
        stickyBar.classList.toggle('is-visible', show);
        stickyBar.setAttribute('aria-hidden', show ? 'false' : 'true');
        if (stickyAdd) stickyAdd.tabIndex = show ? 0 : -1;
      };
      new IntersectionObserver(([e]) => { buttonVisible = e.isIntersecting; sync(); }).observe(addButton);
      if (footer) new IntersectionObserver(([e]) => { footerVisible = e.isIntersecting; sync(); }).observe(footer);
      stickyAdd?.addEventListener('click', () => addButton.closest('form')?.requestSubmit());
    }
  });

  /* ---------- Related products ---------- */
  document.querySelectorAll('[data-recommendations]').forEach(async (el) => {
    if (el.children.length && el.querySelector('.product-grid')) return;
    try {
      const response = await fetch(el.dataset.url);
      const html = await response.text();
      const doc = new DOMParser().parseFromString(html, 'text/html');
      const fresh = doc.querySelector('[data-recommendations]');
      if (fresh && fresh.innerHTML.trim()) el.innerHTML = fresh.innerHTML;
      else el.hidden = true;
    } catch (error) {
      el.hidden = true;
    }
  });
})();
